import { ENV } from "constant";
import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  noIndex = false,
  noFollow = false,
  noImageIndex = false,
}) => {
  if (ENV !== "production") return null;

  const robots = [
    noIndex && "noindex",
    noFollow && "nofollow",
    noImageIndex && "noimageindex",
  ]
    .filter(Boolean)
    .join(",");

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {robots && <meta name="robots" content={robots} />}
    </Helmet>
  );
};

export default SEO;
